<template>
  <div>
    <!-- ========== HEADER ========== -->
    <header id="header" class="u-header">

      <div class="u-header__section">
        <TopBar/>

        <div id="logoAndNav" class="container">
          <!-- Nav -->
          <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
            <Logo/>

            <!-- Responsive Toggle Button -->
            <button type="button" class="navbar-toggler btn u-hamburger"
                    aria-label="Toggle navigation"
                    aria-expanded="false"
                    aria-controls="navBar"
                    data-toggle="collapse"
                    data-target="#navBar">
            <span id="hamburgerTrigger" class="u-hamburger__box">
              <span class="u-hamburger__inner"></span>
            </span>
            </button>
            <!-- End Responsive Toggle Button -->

            <!-- Navigation -->
            <div id="navBar" class="collapse navbar-collapse u-header__navbar-collapse">
              <ul class="navbar-nav u-header__navbar-nav">

                <!-- Button -->
                <li class="nav-item u-header__nav-last-item">
                  <a class="btn btn-sm btn-primary transition-3d-hover" href="#createPostModal"
                     data-modal-target="#createPostModal">
                    Faire un post
                  </a>
                </li>
                <!-- End Button -->

                <li class="nav-item u-header__nav-last-item">
                  <a @click="toggleSearchSection()" class="btn btn-sm btn-outline-primary transition-3d-hover" href="#">
                    {{ isSearchEnabled ? 'Fermer recherche': 'Rechercher' }}
                  </a>
                </li>
              </ul>
              <CreatePostModal/>
              <script type="application/javascript" v-bind:src="hsModalWindowSrc"></script>
              <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
            </div>
            <!-- End Navigation -->
          </nav>
          <!-- End Nav -->
        </div>
      </div>
    </header>
    <!-- ========== END HEADER ========== -->

    <!-- ========== MAIN ========== -->
    <main id="content" role="main">
      <!-- Hero Section -->
      <div v-if="isSearchEnabled" class="container space-2">
        <hr/>
        <div class="w-md-80 w-lg-75 text-center mx-md-auto">
          <div class="mb-5">
            <p>Faites une recherche au niveau des posts à partir de tags</p>
          </div>

          <!-- Form -->
          <form @submit="submitCustomSearch" class="w-lg-75 mx-lg-auto">
            <div class="d-flex align-items-center">
              <div class="input-group u-tagsinput">
                <label>
                  <input ref="tagsInput" value="all,example" type="text" class="form-control" name="search"
                         data-role="tagsinput" style="display: none;">
                </label>
              </div>
              <button type="submit" class="btn text-nowrap ml-3"
                      v-bind:class="{'btn-outline-primary': isCustomSearchLoading, 'btn-primary': !isCustomSearchLoading}"
              >
                <span class="fas fa-search font-size-1 mr-2"></span>
                {{ isCustomSearchLoading?"En cours..":"Rechercher"}}
              </button>
            </div>
          </form>
          <!-- End Form -->
        </div>
        <script type="application/javascript" v-bind:src="tagsInputSrc"></script>
        <hr/>
      </div>
      <!-- End Hero Section -->

      <!-- Blog Listing Section -->
      <div class="container space-2 space-bottom-lg-3">
        <div class="row">
          <div id="stickyBlockStartPoint" class="col-lg-3 u-ver-divider u-ver-divider--none-lg mb-7 mb-lg-0">
            <div class="js-sticky-block mr-lg-3" data-parent="#stickyBlockStartPoint"
                 data-sticky-view="md"
                 data-start-point="#stickyBlockStartPoint"
                 data-end-point="#stickyBlockEndPoint"
                 data-offset-top="24"
                 data-offset-bottom="24">
              <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
                <div id="sidebarNav" class="collapse navbar-collapse">
                  <div class="mt-5 mt-lg-0">
                    <h2 class="h6 font-weight-semi-bold">Posts</h2>
                    <!-- List Group -->
                    <ul class="list-group list-group-flush list-group-borderless mb-0">
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center"
                           v-bind:class="{'list-group-item-action':!(postFilterVal === POST_FILTER.all)}"  href="#"
                           @click="setPostFilterVal(POST_FILTER.all)">
                          Tous
<!--                          <span class="badge border badge-pill">30+</span>-->
                        </a>
                      </li>
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center"
                           v-bind:class="{'list-group-item-action':!(postFilterVal === POST_FILTER.favorites)}" href="#"
                           @click="setPostFilterVal(POST_FILTER.favorites)">
                          Avec mes tags favoris
                        </a>
                      </li>
                    </ul>
                    <!-- End List Group -->
                  </div>

                  <div class="mt-5">
                    <h3 class="h6 font-weight-semi-bold">Categories</h3>

                    <!-- List Group -->
                    <ul class="list-group list-group-flush list-group-borderless mb-0">
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center" href="#"
                           v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.all)}"
                           @click="setCategoryFilterVal(CATEGORY_FILTER.all)">
                          Toutes
                        </a>
                      </li>
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center" href="#"
                           v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.need)}"
                           @click="setCategoryFilterVal(CATEGORY_FILTER.need)">
                          Besoin
                        </a>
                      </li>
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center" href="#"
                           v-bind:class="{'list-group-item-action':!(categoryFilterVal === CATEGORY_FILTER.announcement)}"
                           @click="setCategoryFilterVal(CATEGORY_FILTER.announcement)">
                          Annonce
                        </a>
                      </li>
                    </ul>
                    <!-- End List Group -->
                  </div>

                  <div class="mt-5">
                    <h3 class="h6 font-weight-semi-bold">Tags</h3>

                    <!-- List Group -->
                    <ul class="list-group list-group-flush list-group-borderless mb-0">
                      <li>
                        <a class="list-group-item d-flex justify-content-between align-items-center" href="#"
                           v-bind:class="{'list-group-item-action':!(itemToDisplayVal === itemToDisplay.tags)}"
                           @click="setItemToDisplayVal(itemToDisplay.tags)">
                          Les plus utilisés
                        </a>
                      </li>
                    </ul>
                    <!-- End List Group -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-7 col-lg-8 mb-7 mb-md-0">
            <FlexLoader v-if="$apollo.queries.posts.loading"/>
            <post-list v-else-if="itemToDisplayVal === itemToDisplay.posts" :posts="displayedPosts"/>
            <TagsView v-else-if="itemToDisplayVal === itemToDisplay.tags" :tags="tags"/>

            <div v-if="itemHasNextPage" class="d-flex justify-content-center">
<!--              <LoadingButton v-if="loadMoreRequestIsLoading"/>-->
              <button v-if="!loadMoreRequestIsLoading" @click="loadMore"
                      class="btn btn-xs btn-primary btn-wide transition-3d-hover mt-2">
                Charger plus
              </button>
            </div>

            <!-- Sticky Block End Point -->
            <div id="stickyBlockEndPoint"></div>

            <div class="space-bottom-2"></div>
          </div>

          <script type="application/javascript" v-bind:src="hsSticky.script"></script>
          <script type="application/javascript" v-bind:src="hsSticky.pluginInit"></script>
        </div>
      </div>
      <!-- End Blog Listing Section -->
    </main>
    <!-- ========== END MAIN ========== -->

    <GoToTop/>

    <div hidden>
      <a ref="anchorLink" :href="anchor"></a>
    </div>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import GoToTop from "@/components/GoToTop";
import TopBar from "@/components/TopBar";
import Logo from "@/components/Logo";
import PostList from "@/components/PostList";
import CreatePostModal from "@/components/CreatePostModal";
import FlexLoader from "@/components/FlexLoader";
import TagsView from "@/components/TagsView";
import {HOME_ITEM_TO_DISPLAY, HOME_POST_PAGE_SIZE, POST_CATEGORIES, POST_FILTER} from "@/settings";
import {GET_AUTHENTICATED_USER, GET_POSTS, GET_TAGS} from "@/settings/graphql/index";
import {JS_FILES} from "@/settings/scripts";
import {TagManager} from "@/managers";
import {haveCommonElements} from "@/xlib";

export default {
  name: 'Home',
  components: {TagsView, FlexLoader, CreatePostModal, PostList, Logo, GoToTop, TopBar},
  data() {
    return {
      POST_FILTER: POST_FILTER,
      postFilterVal: POST_FILTER.all,
      CATEGORY_FILTER: POST_CATEGORIES,
      categoryFilterVal: POST_CATEGORIES.all,
      itemToDisplay: HOME_ITEM_TO_DISPLAY,
      itemToDisplayVal: HOME_ITEM_TO_DISPLAY.posts,
      posts: {edges: []},
      tags: {edges: []},
      isSearchEnabled: false,
      searchTags: [],
      isCustomSearchLoading: false,
      authenticatedUser: null,
      loadMoreRequestIsLoading: false,
      itemHasNextPage: false,
      postsPageSize: HOME_POST_PAGE_SIZE,
      tagsPageSize: 50,
      anchor: "#",
      tagsInputSrc: JS_FILES.tagsInput,
      hsCoreSrc: JS_FILES.hs.core,
      hsModalWindowSrc: JS_FILES.hs.modalWindow,
      hsPluginsInitSrc: JS_FILES.hs.pluginsInit.modalWindow,
      hsSticky: JS_FILES.hs.sticky
    }
  },
  apollo: {
    posts: {
      query: GET_POSTS,
      variables (){
        return {first: this.postsPageSize}
      },
      update (data) {
        const posts = data.posts;
        this.itemHasNextPage = posts.pageInfo.hasNextPage;
        return data.posts;
      }
    },
    tags: {
      query: GET_TAGS,
      variables (){
        return {first: this.tagsPageSize}
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        const tags = data.tags;
        this.itemHasNextPage = tags.pageInfo.hasNextPage;
        return data.tags;
      }
    },
    authenticatedUser: {
      query: GET_AUTHENTICATED_USER,
      fetchPolicy: 'cache-and-network',
      update(data){
        const info = data.me;
        this.storeUserInfo(info);
        return info;
      }
    }
  },
  computed: {
    displayedPosts: function () {
      let filteredEdges = this.posts.edges;

      // filter by category
      const categoryFilterVal = this.categoryFilterVal;

      if(categoryFilterVal !== POST_CATEGORIES.all){
        filteredEdges = filteredEdges.filter(function(edge){
          return edge.node.category === categoryFilterVal;
        });
      }

      // filter by posts all / favorite
      const postFilterVal = this.postFilterVal;
      const authenticatedUser = this.authenticatedUser;

      if(postFilterVal === POST_FILTER.favorites) {
        filteredEdges = filteredEdges.filter(function(edge){
          const postTags = TagManager.getNames(edge.node.tagSet);
          const userFavoriteTags = TagManager.getNames(authenticatedUser.tagFavoriteSet);
          return haveCommonElements(postTags, userFavoriteTags);
        });
      }

      // filter for search with tags
      const searchTags = this.searchTags;
      if(this.isSearchEnabled && this.searchTags.length !== 0){
        filteredEdges = filteredEdges.filter(function(edge){
          const postTags = TagManager.getNames(edge.node.tagSet);
          return haveCommonElements(postTags, searchTags);
        });
      }

      return {
        edges: filteredEdges,
        __typename: this.posts.__typename
      };
    }
  },
  methods: {
    ...mapMutations([
      'setUserInfo'
    ]),
    storeUserInfo(info) {
      this.setUserInfo(info);
    },
    setItemToDisplayVal(value) {
      this.itemToDisplayVal = value;
    },
    setPostFilterVal(value) {
      this.postFilterVal = value;
      this.setItemToDisplayVal(this.itemToDisplay.posts);
    },
    setCategoryFilterVal(value) {
      this.categoryFilterVal = value;
      this.setItemToDisplayVal(this.itemToDisplay.posts);
    },
    toggleSearchSection() {
      this.isSearchEnabled = ! this.isSearchEnabled;
      this.setItemToDisplayVal(this.itemToDisplay.posts);
    },
    submitCustomSearch (event) {
      event.preventDefault();
      this.isCustomSearchLoading = true;
      setTimeout(() => {
        this.searchTags = this.$refs.tagsInput.value.split(",");
        this.setItemToDisplayVal(this.itemToDisplay.posts);
        this.isCustomSearchLoading = false;
      }, 1000);
    },
    loadMore (){
      this.loadMoreRequestIsLoading = true;

      if(this.itemToDisplayVal === HOME_ITEM_TO_DISPLAY.posts){
        const currentEndCursor = this.posts.pageInfo.endCursor;
        const currentPostCount = this.posts.edges.length;
        this.$apollo.queries.posts.fetchMore({
          variables: {
            first: this.postsPageSize,
            after: currentEndCursor,
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const previousPosts = previousResult.posts;
            const newPosts = fetchMoreResult.posts;

            this.itemHasNextPage = newPosts.pageInfo.hasNextPage;

            this.loadMoreRequestIsLoading = false;
            this.anchor = `#${previousPosts.edges[currentPostCount-1].node.id}`;

            return {
              posts: {
                edges: [...previousPosts.edges, ...newPosts.edges],
                pageInfo: {
                  endCursor: newPosts.pageInfo.endCursor,
                  hasNextPage: newPosts.pageInfo.hasNextPage,
                  __typename: newPosts.pageInfo.__typename
                },
                __typename: newPosts.__typename
              }
            }
          }
        }).then(() => {
          this.$refs.anchorLink.click();
        });
      }
      else if(this.itemToDisplayVal === HOME_ITEM_TO_DISPLAY.tags){
        const currentEndCursor = this.tags.pageInfo.endCursor;
        const currentTagCount = this.tags.edges.length;
        this.$apollo.queries.tags.fetchMore({
          variables: {
            first: this.tagsPageSize,
            after: currentEndCursor,
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const previousTags = previousResult.tags;
            const newTags = fetchMoreResult.tags;

            this.itemHasNextPage = newTags.pageInfo.hasNextPage;

            this.loadMoreRequestIsLoading = false;
            this.anchor = `#${previousTags.edges[currentTagCount-1].node.id}`;

            return {
              tags: {
                edges: [...previousTags.edges, ...newTags.edges],
                pageInfo: {
                  endCursor: newTags.pageInfo.endCursor,
                  __typename: newTags.pageInfo.__typename,
                  hasNextPage: newTags.pageInfo.hasNextPage,
                },
                __typename: newTags.__typename
              }
            }
          }
        }).then(() => {
          this.$refs.anchorLink.click();
        });
      }
    }
  }
}
</script>
